/**
 * 个人空间上传走的腾讯云 COS Bucket / Region
 *
 * 之前在 usePersonalSpace.uploadPhoto 中硬编码，现统一抽出，
 * 后续若按环境区分，可在此处接 __API_SERVER_HOST__ 判断。
 */
export const PERSONAL_COS_BUCKET = 'net-cloud-1322834237'
export const PERSONAL_COS_REGION = 'ap-guangzhou'
